module.exports = __webpack_public_path__ + "static/img/aesth1.529a521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aesth1.jpg
// module id = 191
// module chunks = 1